export default {"src":"/_next/static/media/logo.69986c3d.svg","height":39,"width":249};